import { login } from "./login";
import { register } from "./register";
import { validate, setUserId, clearUserId, hasStoredUserId, hasAuthTokens, shouldAttemptValidation, bootstrapNativeAuthCache } from "./validation";
import { logout, clearAllClientAuthState } from "./logout";
import { getGoogleSSOLoginUrl, getAppleSSOLoginUrl, exchangeNativeSSOCode, signInWithAppleNative, signInWithGoogleNative } from "./sso";
import { getSessions, revokeSession } from "./sessions";
import { tokenManager } from "./tokenManager";
import { config } from "../config";
import { normalizeEmail } from "@/utils/emailUtils";

const forgotPassword = async (email: string) => {
  const normalizedEmail = normalizeEmail(email);

  const response = await fetch(`${config.API_URL}/user/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-api-token': config.API_SECRET_TOKEN,
    },
    body: JSON.stringify({ email: normalizedEmail }),
  });

  if (!response.ok) {
    throw new Error('Failed to send password reset email');
  }

  return response.json();
};

const verifyEmail = async (token: string) => {
  const response = await fetch(`${config.API_URL}/user/verify-email/${token}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-api-token': config.API_SECRET_TOKEN,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to verify email');
  }

  return response.json();
};

const resetPassword = async (token: string, password: string) => {
  const response = await fetch(`${config.API_URL}/user/reset-password/${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'x-api-token': config.API_SECRET_TOKEN,
    },
    body: JSON.stringify({ password }),
  });

  if (!response.ok) {
    throw new Error('Failed to reset password');
  }

  return response.json();
};

export const authApi = {
  login,
  register,
  validate,
  logout,
  clearAllClientAuthState,
  getGoogleSSOLoginUrl,
  getAppleSSOLoginUrl,
  signInWithAppleNative,
  signInWithGoogleNative,
  exchangeNativeSSOCode,
  bootstrapNativeAuthCache,
  forgotPassword,
  verifyEmail,
  resetPassword,
  getSessions,
  revokeSession,
  refreshTokens: () => tokenManager.refreshTokens(),
  setUserId,
  clearUserId,
  hasStoredUserId,
  hasAuthTokens,
  shouldAttemptValidation,
};
